import axios from 'axios'
import defaultOptions from '../../api/defaultoption'
import { StatusNegociacao } from '../../types/negociacao'
import {
  GetGimplusExtratoResponse,
  GetGimplusSaldoResponse
} from '../../types/gimplus'

export async function getGimplusExtrato(
  TipoOperacao?: StatusNegociacao | string,
  Numero?: string,
  DataInicial?: string,
  DataFinal?: string,
  Page?: number,
  PageSize?: number
): Promise<GetGimplusExtratoResponse> {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_GIMPLUS}extrato`,
    {
      headers: defaultOptions.headers,
      params: {
        TipoOperacao,
        Numero,
        DataInicial,
        DataFinal,
        Page,
        PageSize: 10
      }
    }
  )

  return data as GetGimplusExtratoResponse
}

export async function getGimplusSaldo(): Promise<GetGimplusSaldoResponse> {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_GIMPLUS}saldo`,
    {
      headers: defaultOptions.headers
    }
  )

  return data as GetGimplusSaldoResponse
}
